import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { EventService } from '../../../services/EventService';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    /**
     * disabled: desactive le formulaire
     */
    disabled: boolean;
    /**
     * event: l'evenement courant
     */
    event: ReqType.Event;
    /**
     * permet la modification d'un evenement
     * @param {Event} event
     */
    setEvent: (event: ReqType.Event) => void;
}

/**
 * interface State (l'état interne de la classe EventDetailForm)
 */
interface State {
}

/**
 * Ce composent représente un formulaire pour ajouter les details d'un associer à un évèment.
 * Il prend un booleen et un évènement en paramétre et n'utilise pas de service
 */
export class EventDetailForm extends React.Component {
    /** le props: l'etat externe */
    props: Props;
    /** le state: l'etat interne */
    state: State;

    /**
     * construit le formulaire de detaillant un event
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    /**
     * le rendu de la classe Event Detail Form
     * @returns {JSX.element}
     */
    render() {
        return (
            <div className="form-group">
                <div>
                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.4cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >Intitulé:
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Intitulé"
                            type="text"
                            disabled={this.props.disabled}
                            value={this.props.event.intitule}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    const dupEvent = EventService.getInstance().duplicateEvent(this.props.event);
                                    dupEvent.intitule = e.target.value;
                                    this.props.setEvent(dupEvent);
                                }
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.4cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Description:
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Description"
                            type="text"
                            disabled={this.props.disabled}
                            value={this.props.event.description}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    const dupEvent = EventService.getInstance().duplicateEvent(this.props.event);
                                    dupEvent.description = e.target.value;
                                    this.props.setEvent(dupEvent);
                                }
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.4cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Budget:
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Budget"
                            type="text"
                            disabled={this.props.disabled}
                            value={this.props.event.budget}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    const dupEvent = EventService.getInstance().duplicateEvent(this.props.event);
                                    dupEvent.budget = e.target.value;
                                    this.props.setEvent(dupEvent);
                                }
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/EventDetailForm.tsx